module.exports = __webpack_public_path__ + "static/media/personal-data-accounts.30d4bcf8.svg";